import PropTypes from "prop-types"
import React from "react"
import { Routes, Route } from "react-router-dom"
import { connect } from "react-redux"

// Import Routes all
import {
  frontendRoutes,
  userRoutes,
  authRoutes,
  adminRoutes,
} from "./routes/allRoutes"

// Import all middleware
import Usermiddleware from "./routes/middleware/Usermiddleware"
import Adminmiddleware from "./routes/middleware/Adminmiddleware"

// layouts Format
import NonAuthLayout from "./components/NonAuthLayout"
import "./assets/styles.scss"
import "./assets/scss/theme.scss"

import ScrollToTop from "components/Common/ScrollToTop"

const App = () => {
  return (
    <React.Fragment>
      <ScrollToTop />
      <Routes>
        <Route>
          {authRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        <Route>
          {userRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<Usermiddleware>{route.component}</Usermiddleware>}
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        <Route>
          {adminRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<Adminmiddleware>{route.component}</Adminmiddleware>}
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        <Route>
          {frontendRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={route.component}
              key={idx}
              exact={true}
            />
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}

export default connect(mapStateToProps, null)(App)
